<dialog-title *ngIf="data?.title">
    <h1>{{ data?.title }}</h1>
</dialog-title>
<div class="msg-content" 
    *ngIf="data?.description"
    [class.empty]="data?.button === null" 
    [innerHTML]="data?.description"
></div>
<dialog-actions *ngIf="data?.button !== null">
    <button sc-stroked-button (click)="close()">{{ data?.button || 'Zamknij' }}</button>
</dialog-actions>